import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
export function Sensory() {
  return <section className="py-32 lg:py-48 bg-cream text-chocolate" data-id="element-211">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-14 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="lg:col-span-5 lg:order-1 order-2" data-id="element-213">
          <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-214">
            <span className="w-10 h-px bg-caramel/50" data-id="element-215" />
            The Vessel
          </div>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-chocolate leading-[0.95] tracking-[-0.02em] font-light" data-id="element-216">
            Made to be
            <br data-id="element-217" />
            <span className="italic font-extralight" data-id="element-218">Given.</span>
          </h2>
          <p className="mt-10 text-chocolate/60 leading-[1.8] text-[15px] max-w-md" data-id="element-219">
            Each cheesecake arrives in a hand-finished round box, embossed with
            the TARTA mark and lined with care. A vessel meant to be opened
            slowly — the unboxing is part of the gift.
          </p>

          <div className="mt-12 grid grid-cols-2 gap-x-8 gap-y-6" data-id="element-220">
            {[{
            l: 'Material',
            v: 'Embossed paperboard'
          }, {
            l: 'Finish',
            v: 'Cocoa & cream foil'
          }, {
            l: 'Form',
            v: 'Hand-finished round'
          }, {
            l: 'Detail',
            v: 'A slice of heaven'
          }].map(s => <div key={s.l} data-id="element-221">
                <p className="text-[10px] tracking-[0.3em] uppercase text-chocolate/40 mb-3" data-id="element-222">
                  {s.l}
                </p>
                <p className="font-serif text-lg text-chocolate font-light" data-id="element-223">
                  {s.v}
                </p>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 1.02
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="lg:col-span-7 lg:order-2 order-1 relative group" data-id="element-224">
          <div className="aspect-[5/4] overflow-hidden bg-warmwhite" data-id="element-225">
            <img src={IMAGES.box} alt="The TARTA signature box — embossed cocoa lid with cream foil mark" className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.03]" data-id="element-226" />
          </div>
          <div className="mt-4 flex items-center justify-between text-[10px] tracking-[0.3em] uppercase text-chocolate/40" data-id="element-227">
            <span data-id="element-228">Detail Nº 002</span>
            <span data-id="element-229">The Box</span>
          </div>
        </motion.div>
      </div>
    </section>;
}